module.exports = __webpack_public_path__ + "public/StoreIcon/done.png?50a55494";